/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from 'react';
import { PowerpointExperiment } from '../../experiments/TrialConversion/PowerpointExperiment';

export const PowerpointView = () => {
    return <PowerpointExperiment />;
};

export default PowerpointView;
